module.exports = __webpack_public_path__ + "static/media/film-production-grid-4.2dbda75e.jpg";